export const FINAL_VALIDATION_QUERY_KEY = 'finalValidation';
const FINAL_VALIDATION_QUERY_VALUE = '1';

export function isFinalValidationRequested(searchParams: URLSearchParams): boolean {
  return searchParams.get(FINAL_VALIDATION_QUERY_KEY) === FINAL_VALIDATION_QUERY_VALUE;
}

export function appendFinalValidationSearchParam(path: string): string {
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${FINAL_VALIDATION_QUERY_KEY}=${FINAL_VALIDATION_QUERY_VALUE}`;
}

type SetSearchParams = (
  next: URLSearchParams | ((previous: URLSearchParams) => URLSearchParams),
  options?: { replace?: boolean },
) => void;

export function clearFinalValidationSearchParam(setSearchParams: SetSearchParams) {
  setSearchParams(
    (previous) => {
      if (!previous.has(FINAL_VALIDATION_QUERY_KEY)) {
        return previous;
      }
      const next = new URLSearchParams(previous);
      next.delete(FINAL_VALIDATION_QUERY_KEY);
      return next;
    },
    { replace: true },
  );
}
